import { PathDisplayInterface } from "./pathDisplay.interface";
function PathDisplayIndex(props: PathDisplayInterface): JSX.Element {
    return (
        <div className={"flex flex-wrap-reverse items-start"} dir={"ltr"}>
            {props.TextInput.split("/")
                .reverse()
                .map((item) => {
                    if (item !== "") {
                        return (
                            <span key={item} className="flex items-center">
                                <div className="truncate max-w-[100px]">{item}</div>
                                <span>{item.includes("فایل‌های من") ? "" : "/"}</span>
                            </span>
                        );
                    }
                })}
        </div>
    );
}

export default PathDisplayIndex;
